module.exports = __webpack_public_path__ + "img/theHUB-logo.28da7e77.png";